import { Img } from "container/Manual/components/content/Image";
import { PageLink } from "container/Manual/components/content/PageLink";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DATEVALUE = () => {
  return (
    <CardSection id="DATEVALUE" title="DATEVALUE">
      <Paragraph>
        계산에 사용할 수 있도록 날짜/시간 텍스트 문자열을 날짜/시간 개체로
        변환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DATEVALUE(DATETIME, FORMAT, TIME_ZONE)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 텍스트 문자열 형식의 날짜/시간입니다.
          </Li>
          <Li>
            <b>FORMAT</b>은 <b>DATETIME</b>의 현재 형식입니다.
          </Li>
          <Li>
            <b>TIMEZONE</b>은 날짜/시간 객체와 연결하려는 시간대입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>DATEVALUE(`Date`, "yyyy", "Asia/Seoul")</Paragraph>
        <Img src="computeDateValue" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>FORMAT</b>에 사용할 구문에 대한 자세한 내용은{" "}
          <PageLink label="Date and Time Syntax" url="#" /> 문서를 참조하세요.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
